module.exports = __webpack_public_path__ + "f1a5c16a30ab4c1a078390975b452e27.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-08-harrison-allepey/diary2.jpg
// module id = 583
// module chunks = 0